const humanizeFieldName = (field) =>
  String(field)
    .replace(/\./g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toLowerCase();

export const getItemFieldValue = (item, field) => {
  if (typeof field === "function") {
    return field(item);
  }

  if (item == null || field == null) {
    return "";
  }

  return String(field)
    .split(".")
    .reduce((value, key) => value?.[key], item);
};

export const normalizeSearchText = (value) => {
  if (value == null) {
    return "";
  }

  return String(value).toLowerCase();
};

export const buildSearchPlaceholder = (searchableFields = [], fieldLabels = {}) => {
  if (!searchableFields.length) {
    return "Search...";
  }

  const labels = searchableFields.map((field) => {
    if (typeof field === "function") {
      return fieldLabels.function ?? "value";
    }

    return fieldLabels[field] ?? humanizeFieldName(field);
  });

  return `Search by ${labels.join(", ")}...`;
};

export const itemMatchesSearchTerm = (item, normalizedQuery, searchableFields) => {
  if (!normalizedQuery) {
    return true;
  }

  if (!searchableFields?.length) {
    return normalizeSearchText(item).includes(normalizedQuery);
  }

  return searchableFields.some((field) =>
    normalizeSearchText(getItemFieldValue(item, field)).includes(normalizedQuery)
  );
};

export const filterItemsBySearchTerm = (items, searchTerm, searchableFields) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const normalizedQuery = searchTerm.trim().toLowerCase();

  if (!normalizedQuery) {
    return items;
  }

  return items.filter((item) =>
    itemMatchesSearchTerm(item, normalizedQuery, searchableFields)
  );
};
